



































































































































































































import {Component, Watch} from 'vue-property-decorator';
import {educationModule, Education} from '@/store/modules/education';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import DebounceMixin from '@/mixins/DebounceMixin';
import {swalSuccess, swalError} from '@/plugins/swal';

@Component
export default class FormEducation extends mixins(
  LoadingMixin,
  DebounceMixin,
  SnackbarMixin,
) {
  @educationModule.State('institution') institution!: Education[];
  @educationModule.Action('getInstution') getInstution!: Function;
  @educationModule.State('skills') skills!: Education[];
  @educationModule.Action('getSkills') getSkills!: Function;

  getColor(status: number) {
    return status === 1 ? 'success' : 'error';
  }
  showAddFrom = false;
  form = {
    education_level: '',
    institution: null,
    faculty: null,
    city: null,
    graduation_year: null,
    gpa: null,
  };
  listEducation = [];
  listpenyakit = [];
  list_education_level = [
    'SMP',
    'SMA/SMK/MA Sedrajat',
    'D1',
    'D2',
    'D3',
    'D4',
    'S1',
    'S2',
    'S3',
  ];
  listEducationFaculty = [];
  searchInstitution = '';
  profileEdit = false;
  isLoading = false;
  items = [
    {
      color: 'primary',
      icon: 'mdi-schoor',
    },
  ];
  get rules() {
    return {
      education_level: 'required',
      institution: 'required',
      faculty: 'required',
      city: 'required',
      graduation_year: 'required',
      gpa: '',
    };
  }
  @Watch('searchInstitution')
  onSearcInstitutionChanged(val: string) {
    if (!val) return;

    this.debounce(() => {
      this.searchAll(val);
    }, 1000);
  }
  async mounted() {
    await this.getSkills();
  }
  async searchAll(value: string) {
    this.startLoading('lookup');
    await this.getInstution({
      search: value,
    });
    this.finishLoading('lookup');
  }
  async onSubmit() {
    try {
      this.startLoading('saving');
      const res = await this.$store.dispatch(
        'education/createEducation',
        this.form,
      );
      if (res.status === 200) {
        this.finishLoading('saving');
        swalSuccess.fire({
          title: 'Success!',
          text: res.data.message,
        });
        this.$router.push('/education');
      }
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
}
